import { Tooltip } from '@mui/material';
import { FC } from 'react';

import { changeHandStatus } from '../../../studentApp/api/sendRaisedHand/util';
import { useLayout, useProcessedBannerStore } from '../../../studentApp/hooks';
import { bannerStore, problemState } from '../../../studentApp/stores';
import { BOX_SHADOW } from '../../constants';
import { ButtonText } from '../problem/needHelpButton';

const HandIcon: FC<{ fill: string; stroke: string }> = ({ fill, stroke }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 30 50"
    xmlSpace="preserve"
  >
    <path
      d="M29.9,12.5c-0.2-1.9-1.8-3.4-3.8-3.4c-0.6,0-1.2,0.1-1.7,0.4V7.3c0-0.1,0-0.2,0-0.2c-0.2-1.9-1.9-3.4-3.8-3.4
	c-0.6,0-1.2,0.1-1.7,0.4V3.7c0-0.1,0-0.2,0-0.2C18.6,1.5,16.9,0,14.9,0c-2,0-3.6,1.5-3.8,3.3c0,0.1,0,0.2,0,0.3v0.4
	C10.6,3.8,10,3.7,9.4,3.7c-2,0-3.6,1.5-3.8,3.3c0,0.1,0,0.2,0,0.3v7.9c-0.5-0.3-1.1-0.4-1.7-0.4c-2,0-3.6,1.4-3.8,3.3
	c0,0.1,0,0.2,0,0.3v16.8c0,8.1,6.7,14.7,14.9,14.7s14.9-6.6,14.9-14.7V12.8C29.9,12.7,29.9,12.6,29.9,12.5z"
      fill={stroke}
      stroke={stroke}
      strokeWidth={1}
      strokeMiterlimit={10}
    />
    <path
      d="M28.1,12.8l-0.3,0.1
	v22.3c0,6.9-5.8,12.6-12.8,12.6S2.1,42.1,2.1,35.2l0-16.6c0-0.1,0-0.1,0-0.1c0.1-0.9,0.8-1.5,1.7-1.5c0.9,0,1.6,0.7,1.7,1.6v6.3
	c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1v-6.5c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1l0-10.8c0.1-0.9,0.8-1.6,1.7-1.6
	c0.9,0,1.6,0.7,1.7,1.6v17.5c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1l0-21c0,0,0-0.1,0-0.1c0.1-0.9,0.8-1.6,1.7-1.6
	c0.9,0,1.6,0.7,1.7,1.6v21.1c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1l0-17.5c0.1-0.9,0.8-1.6,1.7-1.6c0.9,0,1.6,0.7,1.7,1.5
	c0,0,0,0.1,0,0.1c0,0,0,0,0,0v17.4c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1l0-12c0.1-0.9,0.8-1.6,1.7-1.6c0.9,0,1.6,0.7,1.7,1.6
	L28.1,12.8L28.1,12.8L28.1,12.8L28.1,12.8z"
      fill={fill}
      stroke={stroke}
      strokeWidth={1}
      strokeMiterlimit={10}
    />
  </svg>
);

export const Hand: FC = () => {
  const { themeColor, contrastingThemeColor } = useProcessedBannerStore();
  const [isHandRaised] = bannerStore(state => [state.isHandRaised]);
  const { isMobile } = useLayout();

  const fill = isHandRaised ? contrastingThemeColor : themeColor;
  const stroke = 'white';

  const setRaiseHand = (raised: boolean): void => {
    const currentProblemId = problemState().selectedID;

    if (!currentProblemId) {
      return;
    }

    changeHandStatus(raised, currentProblemId);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width: 'auto',
        backgroundColor: isMobile ? undefined : themeColor,
        height: isMobile ? '38px' : '30px',
        borderRadius: '8px',
        marginLeft: '10px',
        flexShrink: 0,
        overflow: 'hidden',
        boxShadow: isMobile ? undefined : BOX_SHADOW,
        cursor: 'pointer',
      }}
      onClick={() => setRaiseHand(!isHandRaised)}
    >
      <Tooltip
        title={isHandRaised ? 'Remove help request' : 'Ask teacher for help'}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            width: 'max-content',
            minWidth: isMobile ? undefined : '120px',
            flexShrink: 0,
          }}
        >
          {!isMobile && (
            <span style={{ color: 'white', marginLeft: '5px' }}>
              <ButtonText mainText="Request Help" />
            </span>
          )}
          <div
            style={{
              height: isMobile ? '30px' : '21px',
              width: isMobile ? '20px' : '14px',
              flexShrink: 0,
              margin: '1px 5px 4px 5px',
            }}
          >
            <HandIcon fill={fill} stroke={stroke} />
          </div>
        </div>
      </Tooltip>
    </div>
  );
};
